import { CommitteeInput } from './create-new-foundation-committees-input';

export interface UpdateCommitteeInput {
  foundationId: string;
  committeeId: string;
  committee: CommitteeInput;
}
